import { SizeType } from '@config/type'
import cn from 'classnames'

import { ReactComponent as LoupeIcon } from './assets/img/icon-loupe.svg'

import styles from './logo-loop.module.css'

type LogoLoupeProps = {
  className?: string
  appearance?: 'primary' | 'accent' | 'inverse' | 'inactive'
  size?: SizeType
}

export const LogoLoupe = ({
  className,
  appearance = 'primary',
  size = 'md'
}: LogoLoupeProps) => {
  return (
    <LoupeIcon
      className={cn(styles.container, className, {
        [styles.primary]: appearance === 'primary',
        [styles.accent]: appearance === 'accent',
        [styles.inverse]: appearance === 'inverse',
        [styles.inactive]: appearance === 'inactive',
        [styles.xs]: size === 'xs',
        [styles.sm]: size === 'sm',
        [styles.md]: size === 'md',
        [styles.lg]: size === 'lg'
      })}
    ></LoupeIcon>
  )
}
